<template>
  <div class="search-container">
    <input 
      v-model="query" 
      @input="onSearch" 
      class="search-input" 
      type="text" 
      placeholder="Wyszukaj..." 
    />
  </div>
</template>

<script>
export default {
  name: "DynamicSearch",
  props: {
    data: {
      type: Array,
      required: true
    },
    keysToSearch: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      query: ""
    };
  },
  methods: {
    /**
     * Funkcja usuwająca polskie znaki diakrytyczne, konwertująca je na formę podstawową.
     * Umożliwia wyszukiwanie "diacritic-insensitive" (np. "bak" znajdzie "Bąk").
     * @param {string} text - Tekst do przetworzenia.
     * @returns {string} Przetworzony tekst.
     */
    removeDiacritics(text) {
      if (typeof text !== 'string' || !text) return '';
      
      // 1. Konwersja na małe litery
      // 2. Normalizacja Unicode (NFD) rozdziela znak na podstawowy + diakrytyk
      // 3. Usuwanie łączących znaków diakrytycznych (\u0300-\u036f)
      // 4. Specjalna obsługa dla 'ł', która nie jest poprawnie obsługiwana przez NFD
      return text
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/ł/g, 'l'); 
    },

    /**
     * Główna funkcja wyszukiwania wywoływana przy wprowadzaniu danych.
     */
    onSearch() {
      // 1. Wyczyść i znormalizuj zapytanie użytkownika
      const cleanedQuery = this.removeDiacritics(this.query);

      // Jeśli zapytanie jest zbyt krótkie (po oczyszczeniu), zresetuj wyniki do pełnej listy
      if (cleanedQuery.length < 2) {
        this.$emit("search-results", this.data);
        // Opcjonalnie: emituj 'clear-search' dla nadrzędnego komponentu
        this.$emit("clear-search"); 
        return;
      }

      // 2. Filtrowanie danych
      const filteredData = this.data.filter(item => {
        return this.keysToSearch.some(key => {
          const value = this.getNestedValue(item, key);
          
          // Wyczyść i znormalizuj wartość z danych przed porównaniem
          const cleanedValue = this.removeDiacritics(value);
          
          // Porównanie: czy oczyszczona wartość zawiera oczyszczone zapytanie
          return cleanedValue.includes(cleanedQuery);
        });
      });

      // 3. Emitowanie wyników
      this.$emit("search-results", filteredData);
    },

    /**
     * Pobiera zagnieżdżoną wartość z obiektu, obsługując notację kropkową i tablice.
     * Zwraca ciąg znaków gotowy do wyszukiwania.
     */
    getNestedValue(obj, key) {
      const keys = key.split('.');
      let value = obj;

      for (let i = 0; i < keys.length; i++) {
        if (value === undefined || value === null) {
          return "brak danych";
        }
        
        if (Array.isArray(value)) {
          // Jeśli trafiliśmy na tablicę (np. 'passenger'), połącz wszystkie pasujące wartości spacją
          value = value
            .map(item => item && item[keys[i]])
            .filter(v => v !== undefined && v !== null)
            .join(' ');
        } else {
          // Pobierz wartość z obiektu
          value = value[keys[i]];
        }

        if (value === undefined || value === null) {
          return "brak danych";
        }
      }

      return value !== null && value !== undefined && value.toString().trim() !== ""
        ? value.toString()
        : "brak danych";
    }
  }
};
</script>

<style scoped>
.search-container {
  margin-bottom: 20px;
}

.search-input {
  padding: 8px;
  width: 100%;
  max-width: 400px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: black;
}
</style>